// @flow
import * as React from 'react';

import type { List } from 'immutable';
import { noop, ceil } from 'lodash/fp';
import styled from 'styled-components';
import { VelocityComponent } from 'velocity-react';

const Circle = styled.circle`
    fill: ${props =>
        props.isActive
            ? props.isVariableColour ? `rgb(${props.rgb.toString()})` : props.theme.mainBrandColor
            : props.theme.offlineGrey};
`;

const HitCircle = styled.circle`pointer-events: fill;`;

const startAnimationRadiusCirclePosition = 30;
const bigRadiusCirclePosition = 43;
const offsetX = 50;
const offsetY = 50;
const maxCircleRadius = 4;
const minCircleRadius = 1;

type CircleWithHitAreaProps = {
    delay?: number,
    disabled?: boolean,
    isVariableColour?: boolean,
    items: List<*>,
    onClick?: noop,
    purpose?: string,
    rScale: number,
    rgb?: Uint8ClampedArray,
    selectedValue?: number,
    value?: number,
    xFactor: number,
    yFactor: number
};

const CircleWithHitArea = ({
    items,
    delay,
    onClick,
    rScale,
    selectedValue,
    value,
    xFactor,
    yFactor,
    disabled,
    rgb,
    isVariableColour,
    purpose
}: CircleWithHitAreaProps) => {
    const initialCx = `${xFactor * startAnimationRadiusCirclePosition + offsetX}%`;
    const initialCy = `${yFactor * startAnimationRadiusCirclePosition + offsetY}%`;
    const finalCx = `${xFactor * bigRadiusCirclePosition + offsetX}%`;
    const finalCy = `${yFactor * bigRadiusCirclePosition + offsetY}%`;
    const r = `${minCircleRadius + (maxCircleRadius - minCircleRadius) * rScale}%`;

    // $FlowFixMe
    const minDotValue = items.first().get('value');
    const dotValue = selectedValue && selectedValue < 8 ? minDotValue : ceil(selectedValue, -1);

    return (
        <g aria-label={purpose}>
            <VelocityComponent
                animation={{
                    opacity: 1,
                    cx: finalCx,
                    cy: finalCy
                }}
                delay={delay}
                duration={400}
                easing="ease-in-out"
                runOnMount
            >
                <Circle
                    cx={initialCx}
                    cy={initialCy}
                    isActive={!disabled && value <= dotValue}
                    isVariableColour={isVariableColour}
                    r={r}
                    rgb={rgb}
                />
            </VelocityComponent>
            <HitCircle cx={finalCx} cy={finalCy} fillOpacity="0" onClick={onClick} r={`${maxCircleRadius}%`} />
        </g>
    );
};

export default CircleWithHitArea;



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/brightness-flipper/hit-circle.js